// JS for block-specific behavior only
console.log('res full width cta block loaded');